<template>
  <CCollapsibleCard theme="shadow-low" class="c-time-registration-jobs-card">
    <template #toggle>
      <h3 class="c-time-registration-jobs-card-title">{{ $t('timeRegistrationModal.jobs') }}</h3>
    </template>

    <template #content>
      <CForm @submit="submit" class="u-p-4">
        <CShelf class="u-mb-4">
          <template #left>
            <CButton type="submit" theme="main-primary">
              <CIcon name="play"/>
              <template v-if="!Array.isArray(selectedJobs)">{{ $t('timeRegistrationModal.startSingle') }}</template>
              <template v-else-if="selectedJobs.length === 0">{{ $t('timeRegistrationModal.startAll') }}</template>
              <template v-else>{{ $t('timeRegistrationModal.start', { jobs: selectedJobs.length }) }}</template>
            </CButton>
          </template>

          <template #right>
            {{ durationFromMinutes(container.allowedMinutes) }}
          </template>
        </CShelf>

        <CField :type="canSelectMultiple ? 'checklist' : 'radio'" v-model="selectedJobs" :options="jobs" required>
          <template #option="{ option: option }">
            <CJob :job="option">
              <template #right>
                {{ durationFromMinutes(option.allowedMinutes) }}
              </template>
            </CJob>
          </template>
        </CField>
      </CForm>
    </template>
  </CCollapsibleCard>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import AuthService from '@/general/services/AuthService';
  import CCollapsibleCard from '@/shared/components/CCollapsibleCard.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CShelf from '@/shared/components/CShelf.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import CField from '@/shared/components/form/CField.vue';
  import CForm from '@/shared/components/form/CForm.vue';
  import { durationFromMinutes } from '@/shared/utils/dateTime';
  import { present } from '@/shared/utils/typescript';
  import Job from '../../models/Job';
  import JobContext from '../../models/JobContext';
  import TimeRegistrationService from '../../services/TimeRegistrationService';
  import CJob from '../CJob.vue';

  const props = defineProps<{
    context: JobContext,
  }>();

  const canSelectMultiple = computed(() => AuthService.getCurrentUser().getOutlet(props.context.dossier.outletId).canStartMultipleJobs);

  const selectedJobs = ref(canSelectMultiple.value ? [] : null);

  const container = computed(() => present(props.context.timeRegistrationContainer));

  const jobs = computed(() => container.value?.jobs ?? []);

  function submit() {
    TimeRegistrationService.create(getAffectedJobs(), props.context);
  }

  function getAffectedJobs(): Array<Job> {
    if (!Array.isArray(selectedJobs.value)) {
      return [selectedJobs.value];
    } else if (selectedJobs.value.length > 0) {
      return selectedJobs.value;
    } else {
      return jobs.value;
    }
  }
</script>

<style lang="scss">
  .c-time-registration-jobs-card {
    margin-top: 1rem;

    &-title {
      font-weight: $font-weight-semibold;
      text-align: center;
    }
  }
</style>